import baseSavingActions from '../base-saving-actions/index';

const updateActivePageId = (pageId) => baseSavingActions.setSiteMeta(['activePage'], pageId);

export default updateActivePageId;
